/**
 * A lightweight module-level registry that holds a reference to the currently
 * active ProseMirror EditorView.  This lets OverallSearchPopup (which lives in
 * the header, outside KendoEditor's component tree) access the editor view for
 * "Find in Document" search without threading props through the entire tree or
 * storing a non-serialisable ref in Redux.
 */

let _activeView = {};

/** Called by KendoEditorContent after the editor mounts / its view is ready. */
export const registerEditorView = (ydocRoom, view) => {
  _activeView[ydocRoom] = view;
};

/** Called by KendoEditorContent in its cleanup / unmount effect. */
export const unregisterEditorView = (ydocRoom) => {
  if(_activeView[ydocRoom]) {
    delete _activeView[ydocRoom];
  }
};

/** Returns the currently active EditorView, or null if none is registered. */
export const getActiveEditorView = (ydocRoom) => {
  return _activeView[ydocRoom];
}
